import {
  AbstractControl,
  AsyncValidatorFn,
  FormControl,
  ValidationErrors,
} from '@angular/forms';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LedgerService } from '../../../core/services/ledger-service/ledger.service';

const promotionCodeExists =
  (ledgerService: LedgerService): AsyncValidatorFn =>
  (control: AbstractControl) => {
    const validationError = { invalidCode: true };
    if (!control.value) {
      return of();
    }
    return ledgerService.getPromotionCode(control.value).pipe(
      map((promotionCode) => (promotionCode ? null : validationError)),
      catchError(() => of(validationError)),
    );
  };

export const OnboardingValidators = {
  promotionCodeExists,
};

export const matchingFieldValidator =
  <T>(
    controlToMatch: FormControl<T>,
    initialControl: FormControl<T>,
    errorName: string = 'matches',
  ) =>
  (): ValidationErrors | null =>
    !initialControl.value ||
    !controlToMatch.value ||
    initialControl.value === controlToMatch.value
      ? null
      : {
          [errorName]: false,
        };
